// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__10CmM","modalFooterButton":"ModalNotes_modalFooterButton__loUjD"};